// extracted by mini-css-extract-plugin
export default {"button":"ScrollToTopButton_button__nV4pM","visible":"ScrollToTopButton_visible__jnysm"};